<template>
  <div id="app">
    <nav class="navbar navbar-expand navbar-dark bg-dark">
      <a href="/" class="navbar-brand">BAZAR-CD </a>
      <!-- <div class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link to="/board-home" class="nav-link">
            <font-awesome-icon icon="home" /> Úvod
          </router-link>
        </li>
      </div> -->

      <div v-if="!currentUser" class="navbar-nav">
        <!-- <li class="nav-item">
          <router-link to="/register" class="nav-link">
            <font-awesome-icon icon="user-plus" /> Sign Up
          </router-link>
        </li> -->
        <li class="nav-item">
          <router-link to="/user-login" class="nav-link">
            <font-awesome-icon icon="sign-in-alt" /> Přihlásit
          </router-link>
        </li>
      </div>

      <div v-if="currentUser" class="navbar-nav">
        <li class="nav-item">
          <router-link to="/storecards-list" class="nav-link">
            <font-awesome-icon icon="arrow-right-to-bracket" /> Sklad
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/firms-list" class="nav-link">
            <font-awesome-icon icon="address-card" /> Adresář
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/issuedorder-list" class="nav-link">
            <font-awesome-icon icon="arrow-right-to-bracket" /> Výkup
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/receivedorders-list" class="nav-link">
            <font-awesome-icon icon="arrow-right-from-bracket" /> Prodej
          </router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link to="/receivedorders-list" class="nav-link">
            <font-awesome-icon icon="list-check" /> Objednávky
          </router-link>
        </li> -->
        <!-- <li class="nav-item">
          <router-link to="/eshop-setup" class="nav-link">
            <font-awesome-icon icon="gear" /> Nastavení
          </router-link>
        </li> -->
        <li class="nav-item">
          <a class="nav-link" @click.prevent="logOut">
            <font-awesome-icon icon="sign-out-alt" /> ({{ currentUser[0].name }})
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link">
            <font-awesome-icon icon="shopping-basket" /> ({{ basketItemCount }})
          </a>
        </li>
        <!-- <li>
          <div class="form-group">
        <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1">
              <font-awesome-icon icon="search" />
            </span>
          <input type="text"
            class="form-control"
            placeholder="Hledat"
            autofocus
          >
        </div>
      </div>
        </li> -->
      </div>
      <div class="ml-auto d-flex align-items-center">
        <span class="navbar-text">
          <font-awesome-icon icon="code" />version: {{ currentVersion }}
        </span>
      </div>
    </nav>

    <div class="container-fluid">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
import packageApp from '../package.json';

export default {
  name: 'App',
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentVersion() {
      return packageApp.version;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_ADMIN');
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_MODERATOR');
      }

      return false;
    },
    basketItems() {
      // Keep the computed property implementation
      return this.$store.state.basket.items;
    },
    basketFirm() {
      // Keep the computed property implementation
      return this.$store.state.basket.firm;
    },
    receivedOrder() {
      return this.$store.state.receivedOrder;
    },
    issuedOrder() {
      return this.$store.state.issuedOrder;
    },
    ...mapGetters(['basketItemCount']),
    ...mapGetters(["basketItems"]),
    ...mapGetters(["basketFirm"]),
    ...mapGetters(["receivedOrder"]),
    ...mapGetters(["issuedOrder"]),
  },
  data() {
    return {
      // basketItems: [],
    }
  },
  methods: {
    logOut() {
      console.log('Logout user: ',this.currentUser[0].name)
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    processAndRedirect() {
      this.processBasket();
      this.$router.push('/receivedorder-detail');
    },
    ...mapMutations(['processBasket'])
  }   
};
</script>